export default __webpack_public_path__ + "static/media/menu-sprite.97b2a6b6.svg";